import useId from '../utils/useId';
import * as React from 'react';
export const upsSvg = React.forwardRef(function upsSvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#bi_ups__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M15.85 27.75c.2-.1 5.4-2.35 7.05-3.7 1.7-1.4 2.6-3.4 2.6-5.8V7l-.15-.05c-4.15-2.25-9.3-2.1-9.55-2.1-.2 0-5.35-.15-9.5 2.1L6.2 7v11.3c0 2.4.9 4.4 2.6 5.8 1.65 1.35 6.85 3.6 7.05 3.65Z',
        fill: '#341B14',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M8.65 24.25c1.7 1.35 7.2 3.75 7.2 3.75s5.5-2.4 7.2-3.8c1.8-1.5 2.65-3.55 2.65-5.9V6.65C21.35 4.3 15.85 4.5 15.85 4.5S10.35 4.3 6 6.65v11.7c0 2.35.85 4.4 2.65 5.9Zm.5-.65C7.6 22.35 6.8 20.55 6.8 18.35V11.6c5.4-5 12.3-5.3 18.1-4.75v11.5c0 2.15-.8 4-2.35 5.25-1.35 1.1-5.55 3-6.7 3.5-1.15-.5-5.3-2.35-6.7-3.5Z',
        fill: '#FFB406',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M22.5 18c-.05-.55-.35-.85-1.1-1.3-1.4-.8-1.7-1.5-1.75-2.45 0-1.4 1.2-2.2 2.35-2.25.95-.05 1.6.3 1.9.55v1.5c-.35-.35-.95-.7-1.55-.7-.45 0-1 .25-1 .85 0 .55.42.807.992 1.154l.158.096c1.45.85 1.75 1.65 1.7 2.65 0 1.1-.8 2.3-2.5 2.3-.7 0-1.35-.25-1.9-.55v-1.6c.45.4 1.1.7 1.65.7.65 0 1.05-.35 1.05-.95Zm-6.2 2.4c-.4 0-.65-.05-.8-.1v3.65h-1.7v-11.3c.65-.4 1.4-.6 2.35-.6 2.05 0 3.2 1.55 3.2 4.1 0 2.5-1.1 4.25-3.05 4.25Zm-.724-6.926c.15-.052.355-.124.524-.124 1 0 1.4.8 1.4 2.75 0 1.9-.5 2.8-1.5 2.8-.25 0-.45-.05-.55-.1v-5.3h.05a5.01 5.01 0 0 0 .076-.026ZM12.85 19.7c-.65.45-1.55.7-2.6.7-1.7 0-2.6-.95-2.6-2.8v-5.45H9.4v5.55c0 .45.1 1.2.9 1.2.35 0 .6-.05.8-.2v-6.55h1.75v7.55Z',
        fill: '#FFB406',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `bi_ups__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          transform: 'translate(6 4.496)',
          d: 'M0 0h19.7v23.504H0z',
        }),
      ),
    ),
  );
});
upsSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var ups = {
  category: 'brand',
  colorable: false,
  name: 'ups',
  svg: upsSvg,
};
